@use "styles/abstracts/variables" as v;

.loader {
  display: inline-block;
  border: 4px solid v.$palette-white;
  border-top: 4px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}